// Отсортированные уникальные слаги (products[].product, не id записи рельса — один продукт
// может дать несколько дверей, см. useProductMenu.ts) через запятую. Live-опрос каталога
// (счётчики/статусы) даёт НОВУЮ ссылку products на каждый тик, даже когда состав продуктов не
// поменялся, — сравнивать по ссылке (T-XPRODUCT-DISABLED) означало бы, что installedProducts
// (и ctx, который его несёт) меняется на каждый опрос, дёргая ModuleHost updateCtx
// (ctx?.installedProducts в его deps) без надобности.
export function productSlugsKey(products) {
    return Array.from(new Set(products.map((p) => p.product))).sort().join(",");
}
